<div id="timer">
    <div id="seconds">{{seconds}}:</div>
    <div id="minutes">{{minutes}}</div>
</div>
